import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";
import { R1DashboardProvider } from "@/features/R1Dashboard/context/R1DashboardProvider";
import FundsPortfolioView from "@/features/R1Dashboard/views/FundsPortfolioView";

export default function R1FundsPortfolio() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Portfolio");
  }, []);

  return (
    <R1DashboardProvider>
      <main className="min-h-0 flex flex-1 flex-col overflow-auto bg-white p-5">
        <FundsPortfolioView />
      </main>
    </R1DashboardProvider>
  );
}
